import { Component, Injector, OnInit, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../shared/abstract/component.service';
import { RequestService } from '../../../shared/services/request.service';
import { GeneralQueryModel } from '../../../shared/model/general-query-model';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ActionType } from '../../../shared/enum/actionType';
import { ManagementType } from '../../../shared/enum/managementType';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../../../shared/widgets/modal/modal.component';
import { FileManagerService } from '../../../shared/services/file-manager.service';
import { debounceTime } from 'rxjs/operators';
import { SubscriptionType } from '../../../shared/enum/subscription-type';
import { RegistrationType } from '../../../shared/enum/registration-type';
import { SubscriptionLabelType } from '../../../shared/enum/subscription-label-type';
interface SearchParams {
  searchTerm: string;
  columnName?: string;
}

@Component({
  selector: 'app-company-management',
  templateUrl: './company-management.component.html',
  styleUrl: './company-management.component.css',
})
export class CompanyManagementComponent
  extends ComponentService<any>
  implements OnInit, OnDestroy
{
  dataSource = new MatTableDataSource<any>();
  currentCompany;
  companySearchLength;
  url;
  imagePath: string | null = null;

  pageIndex = 0;
  pageSize = 5;
  currentPage = 0;
  totalPages = 0;
  maxVisibleButtons = 5;
  Math = Math;

  propertiesForColumn: any[] = [];
  searchValuesForColumn: any[] = [];

  isSideNavOpen = false;
  selectedManagementType!: ManagementType;
  selectedActionType!: ActionType;

  ManagementType = ManagementType;
  ActionType = ActionType;

  inputValues: { [key: string]: string | number | null } = {};
  searchInput: string = '';
  private searchSubject: Subject<SearchParams> = new Subject();

  /** Liste filtresi: Kayıt Türü (RegistrationType) */
  allRegistrationTypes: { labelKey: string; value: number }[] = Object.entries(
    RegistrationType
  )
    .filter(([, v]) => !isNaN(Number(v)))
    .map(([key, value]) => ({
      labelKey: `registrationType.${key}`,
      value: Number(value),
    }));

  /** Liste filtresi: Abonelik Etiket Türü (SubscriptionLabelType) */
  allSubscriptionLabelTypes: { labelKey: string; value: number }[] = Object.entries(
    SubscriptionLabelType
  )
    .filter(([, v]) => !isNaN(Number(v)))
    .map(([key, value]) => ({
      labelKey: `subscriptionLabelType.${key}`,
      value: Number(value),
    }));

  /** Liste filtresi: Abonelik Türü (SubscriptionType) */
  allSubscriptionTypes: { value: number }[] = Object.entries(SubscriptionType)
    .filter(([, v]) => !isNaN(Number(v)))
    .map(([, value]) => ({ value: Number(value) }));

  displayedColumns = ['companyLogoUrl', 'companyName', 'registrationTypeId', 'subscriptionLabelId', 'subscriptionTypeId', 'options'];
  selectedCompany?: any;
  subDataSource = new MatTableDataSource<any>();

  constructor(
    private _request: RequestService,
    injector: Injector,
    private _dialog: MatDialog,
    private _fileManager: FileManagerService,
  ) {
    super(injector);

    // Debounce mekanizması
    this.searchSubject.pipe(debounceTime(600)).subscribe((searchParam) => {
      this.filter(searchParam.searchTerm, searchParam.columnName);
    });
  }

  ngOnInit(): void {
    if (
      this._appsService?.existCurrentProject?.companyId &&
      this._appsService?.existCurrentProject?.projectId
    ) {
      this.currentProject = this._appsService.existCurrentProject;
      this.currentCompany = this._appsService.existCurrentCompany;
      this.managementConfig();
    }

    this.cPSubs = this._appsService.currentProject.subscribe((project) => {
      this.currentProject = project;
      this.managementConfig();
    });
    // this.url = environment.apiUrl + '/';
  }

  ngOnDestroy(): void {
    try {
      const rows = this.dataSource?.data || [];
      for (const row of rows) {
        const obj = row?._objectUrl;
        if (obj) {
          try {
            this._fileManager.revokeObjectUrl(obj);
          } catch (e) {}
        }
      }
    } catch (e) {}
  }

  managementConfig() {
    this.getPaginatedQuery();
  }

  getPaginatedQuery() {
    let model: GeneralQueryModel = new GeneralQueryModel();

    model.companyId = this.currentCompany;
    model.propertyNames = this.propertiesForColumn;
    model.searchValues = this.searchValuesForColumn;
    model.and = true;
    model.orderColumn = '';
    model.order = 'desc';
    model.index = this.pageIndex;
    model.size = this.pageSize;

    this._request
      .getPaginatedCompany(model)
      .then((_) => {
        if (_.items) {
          this.dataSource.data = _.items;
          this.dataSource.data.forEach((item) => (item.imagePath = null));
          this.loadImagesForRows(this.dataSource.data);
          this.companySearchLength = _.count;
        }
      })
      .catch((err) => {
        this.MessageBox(err.message ?? '', 'warn', 'center');
      })
      .finally(() => {
        this.updateTotalPages();
      });
  }

  onInputChange(event: Event, columnName?: string): void {
    const inputElement = event.target as HTMLInputElement;
    const searchTerm = inputElement.value;
    this.searchSubject.next({ searchTerm, columnName });
  }

  /** mat-select filtreleri (project-management ile aynı kullanım; anında sorgu). */
  onSelectBoxInputChange(
    value: number | null | undefined,
    columnName: string
  ): void {
    this.inputValues[columnName] =
      value === null || value === undefined ? null : value;
    const searchTerm =
      value === null || value === undefined ? '' : String(value);
    this.filter(searchTerm, columnName);
  }

  filter(searchTerm: string, columnName?: string): void {
    if (columnName) {
      var propertyIndex = this.propertiesForColumn.indexOf(columnName);
      if (propertyIndex != -1)
        if (searchTerm == '' || searchTerm == null || searchTerm == undefined) {
          this.propertiesForColumn.splice(propertyIndex, 1);
          this.searchValuesForColumn.splice(propertyIndex, 1);
        } else this.searchValuesForColumn[propertyIndex] = searchTerm;
      else {
        this.propertiesForColumn.push(columnName);
        var newPropertyIndex = this.propertiesForColumn.indexOf(columnName);
        this.searchValuesForColumn[newPropertyIndex] = searchTerm;
      }
    }

    this.currentPage = 0;
    this.pageIndex = 0;

    this.getPaginatedQuery();
  }

  get visiblePageNumbers(): number[] {
    const start = Math.max(
      0,
      Math.min(
        this.currentPage - Math.floor(this.maxVisibleButtons / 2),
        this.totalPages - this.maxVisibleButtons
      )
    );
    return Array.from(
      { length: Math.min(this.maxVisibleButtons, this.totalPages) },
      (_, i) => start + i + 1
    );
  }

  onPageChange(pageIndex: number) {
    if (pageIndex >= 0 && pageIndex < this.totalPages) {
      this.currentPage = pageIndex;
    }
    this.pageIndex = pageIndex;
    this.getPaginatedQuery();
  }

  updatePageSize(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.pageSize = parseInt(selectElement.value, 10);
    this.updateTotalPages();
    this.currentPage = 0;
    this.pageIndex = 0;
    this.getPaginatedQuery();
  }

  updateTotalPages() {
    this.totalPages = Math.ceil(this.companySearchLength / this.pageSize);
  }

  deleteCompany(element) {
    const dialogRef = this._dialog.open(ModalComponent, {
      width: '400px',
      data: {
        type: 'confirm',
        title: 'deleteCompany',
        body: 'deleteCompanyConfirm',
        ok: 'confirm',
        cancel: 'cancel',
        color: 'warn',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._request
          .deleteCompany(parseInt(element.id))
          .then(async (res) => {
            if (res.code == 1) {
              this.dataSource.data = this.dataSource.data.filter(
                (u) => u.id != element.id
              );
              const fileId = element?._fileId;
              if (fileId) {
                await this._fileManager.deleteFileById(fileId);
              }
              this.MessageBox(res.message ?? '', 'primary', 'center');
            } else if (res.code == 2) {
              this.MessageBox(res.message ?? '', 'orange', 'center');
            } else {
              this.MessageBox(res.message ?? '', 'warn', 'center');
            }
          })
          .catch((err) => {
            this.MessageBox(
              this.languageKey('requiredField'),
              'warn',
              'center'
            );
          });
      }
    });
    this._appsService.logInfo("Şirket silindi");
  }

  openSideNav(
    managementType: ManagementType,
    actionType: ActionType,
    company?: any
  ) {
    this.selectedManagementType = managementType;
    this.selectedActionType = actionType;
    this.isSideNavOpen = true;
    this.selectedCompany = company ? { ...company } : null;
    this._appsService.logInfo("Şirket " + this.languageKey(actionType) + " açıldı");
  }

  private async loadImagesForRows(rows: any[]) {
    if (!rows || rows.length === 0) return;
    for (const row of rows) {
      const id = row?.id;
      if (id == null) {
        row.imagePath = null;
        continue;
      }
      try {
        const res = await this._fileManager.loadImage('CompanyLogo', id);
        row.imagePath = res.sanitizedUrl || null;
        row._objectUrl = res.objectUrl || null;
        const files = res.items || [];
        row._file = files[0] || null;
        row._fileId = row._file?.id || null;

      } catch (e) {
        row.imagePath = null;
        row._objectUrl = null;
        row._file = null;
        row._fileId = null;
      }
    }
    this.dataSource._updateChangeSubscription();
  }

  getSubscriptionTypeName(subscriptionTypeId: number): string {
    switch (subscriptionTypeId) {
      case SubscriptionType.Lite:
        return 'Lite';
      case SubscriptionType.Standart:
        return 'Standart';
      default:
        return '-';
    }
  }

  getRegistrationTypeName(registrationTypeId: number | null | undefined): string {
    if (registrationTypeId === null || registrationTypeId === undefined) {
      return '-';
    }

    // String ise number'a çevir
    const regTypeId = typeof registrationTypeId === 'string' ? Number(registrationTypeId) : registrationTypeId;

    switch (regTypeId) {
      case RegistrationType.None:
        return this.languageKey('registrationType.None') || 'Yok';
      case RegistrationType.Freemium:
        return this.languageKey('registrationType.Freemium') || 'Freemium';
      case RegistrationType.Demo:
        return this.languageKey('registrationType.Demo') || 'Demo';
      case RegistrationType.Enterprise:
        return this.languageKey('registrationType.Enterprise') || 'Enterprise';
      default:
        return '-';
    }
  }

  getSubscriptionLabelTypeName(subscriptionLabelId: number | null | undefined): string {
    if (subscriptionLabelId === null || subscriptionLabelId === undefined) {
      return '-';
    }

    // String ise number'a çevir
    const labelTypeId = typeof subscriptionLabelId === 'string' ? Number(subscriptionLabelId) : subscriptionLabelId;

    switch (labelTypeId) {
      case SubscriptionLabelType.Lite:
        return this.languageKey('subscriptionLabelType.Lite') || 'Lite';
      case SubscriptionLabelType.Standart:
        return this.languageKey('subscriptionLabelType.Standart') || 'Standart';
      case SubscriptionLabelType.Pro:
        return this.languageKey('subscriptionLabelType.Pro') || 'Pro';
      case SubscriptionLabelType.Enterprise:
        return this.languageKey('subscriptionLabelType.Enterprise') || 'Enterprise';
      default:
        return '-';
    }
  }
}
